import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ElectronicsDevice } from '../../models/electronics-device';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-electronics-b2c-device-card',
    templateUrl: './electronics-b2c-device-card.component.html',
    styleUrls: ['./electronics-b2c-device-card.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ElectronicsB2CDeviceCardComponent),
            multi: true,
        },
    ],
    imports: [NgClass],
})
export class ElectronicsB2CDeviceCardComponent implements ControlValueAccessor {
    @Input()
    public device: ElectronicsDevice;
    @Input()
    public selected: string | null = null;

    private onChange: (val: string | null) => void | undefined;
    private onTouch: () => void | undefined;

    public writeValue(): void {}

    public registerOnChange(fn: (val: string | null) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }

    public select(): void {
        if (typeof this.onChange === 'function') {
            this.onChange(this.device.name);
        }
    }
}
